import { ref, watch } from 'vue'
import { safeGet, safeSet } from '@/lib/safeStorage'

/**
 * Table density preference — shared across every list view.
 *
 * Toggling sets the `app-density-compact` class on <html>; `datatable.css`
 * keys its compact padding off that class, so one control re-densifies all
 * tables at once with no per-view wiring. Persisted via safeStorage so
 * Safari private mode / disabled localStorage degrades to in-memory.
 */
const STORAGE_KEY = 'hudstore-density-compact'

// Module-level singleton so the topbar toggle and any reader share one state.
const compact = ref<boolean>(safeGet(STORAGE_KEY) === '1')

function apply(value: boolean) {
  document.documentElement.classList.toggle('app-density-compact', value)
}

// Apply current value immediately on first import (before first paint of lists).
apply(compact.value)

watch(compact, (value) => {
  apply(value)
  safeSet(STORAGE_KEY, value ? '1' : '0')
})

export function useDensity() {
  const toggle = () => {
    compact.value = !compact.value
  }
  return { compact, toggle }
}
